import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

export type ActivationDataStateKind =
  | 'loading'
  | 'processing'
  | 'filter_empty'
  | 'agent_offline'
  | 'thin'
  | 'meaningful'
  | 'error'
  | 'entitlement_restricted'
  | 'none';

/**
 * Shared presentation for activation/explore empty and partial data states.
 * Prefer this over bare empty_list.png or literal 00:00 for unknown values.
 */
@Component({
  selector: 'app-activation-data-state',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="ads" [attr.data-state]="kind" *ngIf="kind !== 'meaningful'">
      <mat-icon class="ads-icon" aria-hidden="true">{{ icon }}</mat-icon>
      <strong class="ads-title">{{ title }}</strong>
      <p class="ads-body" *ngIf="body">{{ body }}</p>
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
      .ads {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.4rem;
        padding: 1.5rem 1rem;
        text-align: center;
        color: #4b5563;
      }
      .ads-icon {
        font-size: 2rem;
        width: 2rem;
        height: 2rem;
        opacity: 0.7;
      }
      .ads-title {
        font-size: 1rem;
        color: #111827;
      }
      .ads-body {
        margin: 0;
        max-width: 28rem;
        font-size: 0.9rem;
        line-height: 1.45;
      }
    `,
  ],
})
export class ActivationDataStateComponent {
  @Input() kind: ActivationDataStateKind = 'none';
  @Input() title = '';
  @Input() body = '';

  get icon(): string {
    switch (this.kind) {
      case 'loading':
      case 'processing':
        return 'hourglass_empty';
      case 'agent_offline':
        return 'wifi_off';
      case 'error':
        return 'error_outline';
      case 'entitlement_restricted':
        return 'lock';
      case 'thin':
        return 'insights';
      case 'filter_empty':
        return 'filter_alt_off';
      default:
        return 'inbox';
    }
  }
}
